module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/banner/ko-8ce8fe2c0cd81028c535fdb09929b98c.jpg";